import { LockOutlined } from '@mui/icons-material';
import { Container, Typography, Box, Paper, Avatar, Link } from '@mui/material';
import NextLink from 'next/link';
import React from 'react';

import LoginForm from '../../components/auth/LoginForm';


const Login: React.FC = () => {
  console.log('Login rendering');
  return (
    <Container component="main" maxWidth="xs" data-testid="login-page">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%',
            borderRadius: 2
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          
          <Box sx={{ width: '100%' }}>
            <LoginForm />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mt: 2 }}>
              <Link component={NextLink} href="/forgot-password" variant="body2">
                Forgot password?
              </Link>
              <Link component={NextLink} href="/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
